import { Toggle } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import DateTimeformatter from '../../../services/ui/datetime/dateTimeFormatter';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';
import CountriesDropdown from '../../portal/countriesDropdown';
import LanguagesDropdownContainer from '../../portal/languagesDropdown';
import PortalDatePicker from '../../portal/portalDatePicker';
import PortalTextBox from '../../portal/portalTextBox';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';
import AddEditUserScrollbars from './addEditUserScrollbars';
import styles from './style.scss';
import RestrictionsTooltip from '../../portal/controls/restrictionsTooltip/restrictionsTooltip';
import GeneratePasswordComponent from '../../common/generatePasswordComponent';

@inject('translationsStore', 'oidcStore', 'usersStore', 'addEditUserStore', 'systemLocalesStore', 'passwordPoliciesStore') @observer
export default class UserAddGeneralForm extends Component {

    fieldsWidth = '325px';

    constructor(props) {

        super(props);
        this.props.passwordPoliciesStore.updatePasswordPolicies(this.props.oidcStore.currentUser.profile.tenant_name);
        this.dates = this.getDatesForDatePicker();
        this.props.addEditUserStore.setExpirationDate(this.dates.defaultDate);
        this.shouldFieldDisabled = this.props.addEditUserStore.isNotLocalAuthenticationType();

        this.state = {
            generatedPassword: ''
        };
    }

    setGeneratedPassword = (password) => {
        this.setState({ generatedPassword: password });
        this.props.addEditUserStore.values.password = password;
        this.props.addEditUserStore.values.confirmedPassword = password;
    };

    handleChangeFirstName = e => this.props.addEditUserStore.setFirstName(e.target.value);
    handleFirstNameOnBlur = e => this.props.addEditUserStore.validateFirstName();

    handleChangeLastName = e => this.props.addEditUserStore.setLastName(e.target.value);
    handleLastNameOnBlur = e => this.props.addEditUserStore.validateLastName();

    handleChangeUserName = e => this.props.addEditUserStore.setUserName(e.target.value);
    handleUserNameOnBlur = e => this.props.addEditUserStore.validateUserName();

    handleChangeEmail = e => this.props.addEditUserStore.setEmail(e.target.value);
    handleEmailOnBlur = e => this.props.addEditUserStore.validateEmail();

    handleChangePassword = e => {
        this.props.addEditUserStore.setPassword(e.target.value);
        this.props.addEditUserStore.validatePassword();
    };

    handleConfirmedPasswordOnChange = e => {
        this.props.addEditUserStore.setConfirmedPassword(e.target.value);
        this.props.addEditUserStore.validateMatchPassword();
    };

    handleChangeJobTitle = e => this.props.addEditUserStore.setJobTitle(e.target.value);

    handleChangePhoneNumber = e => this.props.addEditUserStore.setPhoneNumber(e.target.value);
    handleChangeCellPhoneNumber = e => this.props.addEditUserStore.setCellPhoneNumber(e.target.value);
    handleChangeOther = e => this.props.addEditUserStore.setOther(e.target.value);

    handleCountriesDropdownChange = (e, index, value) => this.props.addEditUserStore.setCountry(value);

    handleChangeActive = e => this.props.addEditUserStore.setActive(e.target.checked);

    handleChangeExpirationDate = (e, date) => this.props.addEditUserStore.setExpirationDate(date);
    handleChangeAllowedIpList = e => this.props.addEditUserStore.setAllowedIpList(e.target.value);
    handleChangeLocaleId = (e, index, value) => this.props.addEditUserStore.setLocaleId(value);

    getDatesForDatePicker() {

        let expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 3);

        if (this.props.addEditUserStore.values.expirationDate !== null
            && this.props.addEditUserStore.values.expirationDate !== '') {

            expirationDate = new Date(this.props.addEditUserStore.values.expirationDate);
        }

        return {
            defaultDate: expirationDate,
            minDate: this.props.addEditUserStore.calulateMinValidDate()
        };
    }

    getPasswordField() {

        return this.shouldFieldDisabled
            ? null
            : <div>
                <PortalTextBox
                    hintText={this.props.translationsStore.translate('PASSWORD')}
                    floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('PASSWORD')}
                        required={!this.shouldFieldDisabled} />}
                    type='password'
                    onChange={this.handleChangePassword}
                    triggerHelpTooltipOnFocus
                    helpTooltipPlacement="right"
                    helpTooltipText={
                        <RestrictionsTooltip isInputPristine={Boolean(this.props.addEditUserStore.values.password)}
                            restrictions={this.props.passwordPoliciesStore.PasswordRestrictions}
                            failingRestrictions={this.props.addEditUserStore.passwordValidationMessage || []} />
                    }
                    disabled={this.props.addEditUserStore.creatingUser}
                    value={this.props.addEditUserStore.values.password}
                    width={this.fieldsWidth}
                    dataCy='add-user-password'
                    autoComplete='new-password'
                />
            </div>;
    }

    getRetypePasswordField() {

        return this.shouldFieldDisabled
            ? null
            : <div>
                <PortalTextBox
                    hintText={this.props.translationsStore.translate('RETYPE_PASSWORD')}
                    floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('RETYPE_PASSWORD')}
                        required={!this.shouldFieldDisabled} />}
                    onChange={this.handleConfirmedPasswordOnChange}
                    onBlur={this.handleConfirmedPasswordOnBlur}
                    errorText={this.props.addEditUserStore.passwordConfirmedValidationMessage}
                    disabled={this.props.addEditUserStore.creatingUser}
                    value={this.props.addEditUserStore.values.confirmedPassword}
                    type='password'
                    width={this.fieldsWidth}
                    dataCy='add-user-retype-password'
                    autoComplete='new-password'
                />
            </div>;
    }

    getUserNameField() {

        return <div>
            <PortalTextBox
                hintText={this.props.translationsStore.translate('USER_NAME')}
                floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('USER_NAME')}
                    required={!this.shouldFieldDisabled} />}
                onChange={this.handleChangeUserName}
                onBlur={this.handleUserNameOnBlur}
                errorText={this.props.addEditUserStore.userNameValidationMessage}
                disabled={this.props.addEditUserStore.creatingUser || this.shouldFieldDisabled}
                value={this.props.addEditUserStore.values.userName}
                width={this.fieldsWidth}
                dataCy='add-user-username'
            />
        </div>;
    }

    render() {

        const { values } = this.props.addEditUserStore;
        let userNameField = this.getUserNameField();
        let passwordField = this.getPasswordField();
        let retypePasswordField = this.getRetypePasswordField();

        const dateTimeformatter = new DateTimeformatter();
        const locale = this.props.oidcStore.currentUser.profile.locale;
        const dateTimeFormat = dateTimeformatter.getDateTimeFormat(locale);

        return (
            <div>
                <ValidationTopErrorMessage errorMessage={this.props.addEditUserStore.addUserErrorMessage} />
                <AddEditUserScrollbars
                    height='60vh'
                >
                    <div>
                        <div
                            className={classNames(styles.userFormWrapper)}
                        >
                            <div>
                                <PortalTextBox
                                    hintText={this.props.translationsStore.translate('FIRST_NAME')}
                                    floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('FIRST_NAME')} required />}
                                    onChange={this.handleChangeFirstName}
                                    onBlur={this.handleFirstNameOnBlur}
                                    errorText={this.props.addEditUserStore.firstNameValidationMessage}
                                    disabled={this.props.addEditUserStore.creatingUser}
                                    value={values.firstName}
                                    width={this.fieldsWidth}
                                    dataCy='add-user-first-name'
                                />
                            </div>
                            <div>
                                <PortalTextBox
                                    hintText={this.props.translationsStore.translate('LAST_NAME')}
                                    floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('LAST_NAME')} required />}
                                    onChange={this.handleChangeLastName}
                                    onBlur={this.handleLastNameOnBlur}
                                    errorText={this.props.addEditUserStore.lastNameValidationMessage}
                                    disabled={this.props.addEditUserStore.creatingUser}
                                    value={values.lastName}
                                    width={this.fieldsWidth}
                                    dataCy='add-user-last-name'
                                />
                            </div>
                            {userNameField}
                            <div>
                                <PortalTextBox
                                    hintText={this.props.translationsStore.translate('EMAIL')}
                                    floatingLabelText={<TextfieldFloatingText title={this.props.translationsStore.translate('EMAIL')} required />}
                                    onChange={this.handleChangeEmail}
                                    onBlur={this.handleEmailOnBlur}
                                    errorText={this.props.addEditUserStore.emailValidationMessage}
                                    disabled={this.props.addEditUserStore.creatingUser}
                                    value={values.email}
                                    width={this.fieldsWidth}
                                    dataCy='add-user-email'
                                />
                            </div>
                            <div>
                                <PortalTextBox
                                    hintText={this.props.translationsStore.translate('JOB_TITLE')}
                                    floatingLabelText={this.props.translationsStore.translate('JOB_TITLE')}
                                    disabled={this.props.addEditUserStore.creatingUser}
                                    onChange={this.handleChangeJobTitle}
                                    value={values.jobTitle}
                                    width={this.fieldsWidth}
                                    dataCy='add-user-job-title'
                                />
                            </div>
                            <div>
                                <PortalTextBox
                                    hintText={this.props.translationsStore.translate('PHONE')}
                                    floatingLabelText={this.props.translationsStore.translate('PHONE')}
                                    onChange={this.handleChangePhoneNumber}
                                    disabled={this.props.addEditUserStore.creatingUser}
                                    value={values.phoneNumber}
                                    width={this.fieldsWidth}
                                    dataCy='add-user-phone'
                                />
                            </div>
                            <div>
                                <PortalTextBox
                                    hintText={this.props.translationsStore.translate('MOBILE_PHONE')}
                                    floatingLabelText={this.props.translationsStore.translate('MOBILE_PHONE')}
                                    onChange={this.handleChangeCellPhoneNumber}
                                    disabled={this.props.addEditUserStore.creatingUser}
                                    value={values.cellPhoneNumber}
                                    width={this.fieldsWidth}
                                    dataCy='add-user-mobile-phone'
                                />
                            </div>
                            <div>
                                <CountriesDropdown
                                    hintText={this.props.translationsStore.translate('COUNTRY')}
                                    floatingLabelText={this.props.translationsStore.translate('COUNTRY')}
                                    onChange={this.handleCountriesDropdownChange}
                                    disabled={this.props.addEditUserStore.creatingUser}
                                    value={values.country}
                                    width={this.fieldsWidth}
                                    translations={{
                                        selectCountry: this.props.translationsStore.translate('SELECT_COUNTRY')
                                    }}
                                />
                            </div>
                            <div>
                                <PortalTextBox
                                    hintText={this.props.translationsStore.translate('OTHER')}
                                    floatingLabelText={this.props.translationsStore.translate('OTHER')}
                                    onChange={this.handleChangeOther}
                                    disabled={this.props.addEditUserStore.creatingUser}
                                    value={values.other}
                                    width={this.fieldsWidth}
                                    dataCy='add-user-other'
                                />
                            </div>
                            <div>
                                <LanguagesDropdownContainer
                                    hintText={this.props.translationsStore.translate('LOCALE')}
                                    floatingLabelText={this.props.translationsStore.translate('LOCALE')}
                                    onChange={this.handleChangeLocaleId}
                                    disabled={this.props.addEditUserStore.creatingUser}
                                    value={values.localeId}
                                    width={this.fieldsWidth}
                                />
                            </div>
                            {passwordField}
                            {retypePasswordField}

                            <GeneratePasswordComponent setGeneratedPassword={this.setGeneratedPassword} />

                            <div style={{ height: '72px' }}>
                                <PortalDatePicker
                                    floatingLabelText={this.props.translationsStore.translate('EXPIRATION_DATE')}
                                    hintText={this.props.translationsStore.translate('EXPIRATION_DATE')}
                                    okLabel={this.props.translationsStore.translate('DONE')}
                                    cancelLabel={this.props.translationsStore.translate('CANCEL')}
                                    onChange={this.handleChangeExpirationDate}
                                    minDate={this.dates.minDate}
                                    DateTimeFormat={dateTimeFormat}
                                    defaultDate={this.dates.defaultDate}
                                    disabled={this.props.addEditUserStore.creatingUser || this.shouldFieldDisabled}
                                    width={this.fieldsWidth}
                                />
                            </div>
                        </div>
                        <div>
                            <Toggle
                                icons={false}
                                onChange={this.handleChangeActive}
                                disabled={this.props.addEditUserStore.creatingUser}
                                checked={values.active}
                                text={this.props.translationsStore.translate('ACTIVE_USER')}
                            />
                        </div>
                    </div>
                    <button type='submit' style={{ display: 'none' }} />
                </AddEditUserScrollbars>
            </div>
        );
    }
}